import { render, staticRenderFns } from "./ProductIntro.vue?vue&type=template&id=339df254&scoped=true&"
import script from "./ProductIntro.vue?vue&type=script&lang=js&"
export * from "./ProductIntro.vue?vue&type=script&lang=js&"
import style0 from "./ProductIntro.vue?vue&type=style&index=0&id=339df254&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "339df254",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
